import React from 'react';
import PropTypes from 'prop-types';
import { appConfig } from '@ami/react/core';
import ProductSelectionRowComponent from './ProductSelectionRowComponent';
//import './ProductSelectionComponent.scss';
import { ProductGroupDimensionVisibilityType } from '../../products/productGroup';

const ProductSelectionComponent = ({
  products,
  onProductSelected,
  productId,
  inventoryItemId,
  productGroup,
  inventoryItems,
  isForInventoryItemCreation,
  noBucketSpecsAvailable,
  thumbBucketLocation,
  thumbExistingBucketBrand
}) => {
  return (
    <table
      className={`table table-mobile step3-product-table ${
        !productId ? 'invalid' : ''
      }`}
    >
      <thead>
        <tr>
          {productGroup.dimensions
            .filter(
              (x) =>
                x.visibilityType !==
                ProductGroupDimensionVisibilityType.NotVisible
            )
            .map((x) => (
              <th key={x.name}>{x.name}</th>
            ))}
          <th>Product Number</th>
          {!isForInventoryItemCreation && (
            <th className="leadtime-header">Lead Time</th>
          )}
          {isForInventoryItemCreation && <th>Weight Categories</th>}
          <th className="select-header"></th>
        </tr>
      </thead>
      <tbody>
        {products.map((product) => (
          <ProductSelectionRowComponent
            key={product.id}
            productId={productId}
            inventoryItemId={inventoryItemId}
            productGroup={productGroup}
            product={product}
            onProductSelected={onProductSelected}
            isForInventoryItemCreation={isForInventoryItemCreation}
            productInventoryItems={inventoryItems.filter(
              (x) =>
                x.productId === product.id &&
                (!x.isRestricted ||
                  appConfig.isManagementApp ||
                  x.id === inventoryItemId)
            )}
            noBucketSpecsAvailable={noBucketSpecsAvailable}
            thumbBucketLocation={thumbBucketLocation}
            thumbExistingBucketBrand={thumbExistingBucketBrand}
          />
        ))}
      </tbody>
    </table>
  )
};

ProductSelectionComponent.propTypes = {
  products: PropTypes.arrayOf(Object),
  onProductSelected: PropTypes.func.isRequired,
  productId: PropTypes.string,
  inventoryItemId: PropTypes.string,
  productGroup: PropTypes.instanceOf(Object),
  inventoryItems: PropTypes.arrayOf(Object),
  isForInventoryItemCreation: PropTypes.bool,
  noBucketSpecsAvailable: PropTypes.bool
};

ProductSelectionComponent.defaultProps = {
  inventoryItems: [],
  isForInventoryItemCreation: false,
};

export { ProductSelectionComponent };
